import { gql } from '@apollo/client';

export default gql`
  query($_id: ID!) {
    tenant(_id: $_id) {
      id
      name
      availableListingTypes
      availableSectors
    }
  }
`;
